import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import CallPlannerItem from "../../Platform/TheHeader/CallPlannerPopover/CallPlannerItem";
dayjs.extend(isBetween);
// import locale from 'dayjs/locale/pl';

export default {
  components: {
    CallPlannerItem
  },
  data() {
    return {
      isPopoverVisible: false
    };
  },

  props: {
    eventData: {
      type: Object,
      default: () => ({})
    },
    colorsForRecords: {
      type: Array,
      default: () => []
    },
    buttonHeight: {
      type: String,
      default: "auto"
    }
  },

  methods: {
    refreshCalendar() {
      this.isPopoverVisible = false;
      this.$emit("refreshCalendar");
    }
  },
  computed: {
    agentsAbleToCall() {
      return this.$store.getters["user/agent/agentsBelongsToUserlist"].records.filter(
        el => el.massdial4call === true
      );
    },
    recordBackgroundColor() {
      const currentEvent = this.colorsForRecords.find(
        item => item.userUuid === this.eventData.user_uuid
      );
      if (currentEvent?.userUuid === this.$store.getters["authorization/user"].user_uuid) {
        return "#4287f5";
      } else if (this.eventData.user_uuid === null) {
        return "#6cf05d";
      } else if (currentEvent?.userUuid !== this.$store.getters["authorization/user"].user_uuid) {
        return currentEvent?.color;
      } else {
        return "grey";
      }
    }
  }
};
